import { S as Swiper } from './index-Cj6iU7wg.js';
import './swiper-core-kdoF3145.js';
import './classes-to-selector-JYvn0qt6.js';

class Quicklinks extends HTMLElement {
  modules = [];

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 'auto',
      spaceBetween: 12,
      breakpoints: {
        768: {
          spaceBetween: 12,
        },
        1440: {
          spaceBetween: 12,
        },
      },
    });
  }
}

customElements.define('quicklinks-swiper', Quicklinks);
